export default "__VITE_ASSET__05d230ab__"